import { render, staticRenderFns } from "./CamerasReports.vue?vue&type=template&id=bc80f406"
import script from "./CamerasReports.vue?vue&type=script&lang=js"
export * from "./CamerasReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports